import { Component, OnInit, ɵConsole } from '@angular/core';
import { NgbDateStruct, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../services/oms-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../../tools/src/lib/shared/shared.service';
import { ConstantsService } from '../services/constants.service';
import { FormGroup, FormControl, FormsModule, Validators, FormBuilder } from '@angular/forms';
//import * as data from './data.';
import { ReportDetailsComponent } from '../modal-popups/report-details/report-details.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { configurton } from '../../assets/data/configuration';
//import { UploadReportComponent } from '../modal-popups/upload-report/upload-report.component';
import { TrackOrderComponent } from '../modal-popups/track-order/track-order.component';
import { DatePipe, JsonPipe } from '@angular/common';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-refund-page',
  templateUrl: './refund-page.component.html',
  styleUrls: ['./refund-page.component.scss']
})
export class RefundPageComponent implements OnInit {

  model: NgbDateStruct;
  bsRangeValue: Date[];
  maxDate = new Date();
  currentDate = new Date();
  page = 1;
  pageSize = 20;
  collectionSize = 0;
  datacount = 0;
  curDate = new Date();
  from: string = "";
  year: String = '';
  month: String = '';
  day: String = '';
  searchForm: FormGroup;
  //verifyOtp:any;
  index = 0;
  selectedFromDate: any;
  selectedToDate: any;
  isOtpSend: boolean = false;
  orderDetailsRes = [];
  orderRequest = {};
  orderRequestBySearch = {};
  searchFormRequest = {};
  role: string = "";
  configuraionData;
  href = "";
  isSelected: boolean = true;
  totalRecords: Number = 0;
  isOrderListDataExist: boolean = false;
  diagnosticCenterList = [];
  orderStatusList: [];
  tenantOrgInfo: any;
  isTrack: Boolean = false;
  fromDate: any;
  endDate: any;
  isAllOrderSearch: Boolean = false;
  tenantsList: any;
  OrgList: any;
  organizationsOfTenants: any;
  dynamicSpan: number;
  hoveredDate: NgbDate | null = null;
  // fromDate: NgbDate | null | any;
  toDate: NgbDate | null;
  selectDate:any;
  formattedFromDate: any;
  formattedToDate: any;
  selectedValue = 'scheduled_date'; 
  options = [
    { label: 'Scheduled Date', value: 'scheduled_date' },
    { label: 'Created Date', value: 'created_date' },
  ];
  refundStatusList = [
    {name:"INITIATED",value:1},
    {name:"PROCESSING",value:2},
    {name:"PROCESSED",value:3},
    {name:"REJECTED",value:4},
  ];

  isPrintDocumentBtn: boolean = false;
  isPendingBtn: boolean = false; 
  fileDownloadDisable :Boolean =true;
  isRefundbtn :Boolean = false;
  status :number;

constructor(
    private omsServiceService: OmsServiceService,
    private _router: Router,
    private sharedService: SharedService,
    private _activatedRoute: ActivatedRoute,
    private constantsService: ConstantsService,
    private modalService: NgbModal,
    private SpinnerService: NgxSpinnerService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private toastr: ToastrService
  ) {

    this.searchForm = new FormGroup({
      searchBy: new FormControl(),
      searchByValue: new FormControl(),
      startDate: new FormControl("", [Validators.required]),
      endDate: new FormControl("", [Validators.required]),
      diagnosticBranch: new FormControl(),
      status: new FormControl('1'),
      selectedTenant: new FormControl(),
      selectedOrg: new FormControl(),
      sortBy:new FormControl('scheduled_date'),
      businessId: new FormControl(),

    });
    // this.fromDate = calendar.getToday();
    // this.toDate = calendar.getNext(calendar.getToday(), 'd', 7);
    this.currentDate=new Date()
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.currentDate, this.maxDate];
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 7);
    this.currentDate=new Date()
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.currentDate, this.maxDate];

    console.log(`this.currentDate,this.maxDate`, this.currentDate,this.maxDate);
  }

  ngOnInit(): void {
    this.omsServiceService.tenantOrgInfo$.subscribe(data => {
      console.log('tenats load for order', data)
      this.tenantOrgInfo = data
      if (!this.tenantOrgInfo) {
        this.dynamicSpan = 10
        this.tenantOrgInfo = [];
        console.log("tenantOrgInfo is empty")
      } else {
        this.dynamicSpan = 8
        console.log("tenantOrgInfo is loaded")
      }

      var uniqueTenants = [];
      var uniqueOrgs = [];
      this.tenantsList = [];
      this.OrgList = [];

      this.tenantOrgInfo.forEach((element, i) => {
        if (!uniqueTenants[this.tenantOrgInfo[i].tenantCode]) {
          this.tenantsList.push(this.tenantOrgInfo[i]);
          uniqueTenants[this.tenantOrgInfo[i].tenantCode] = 1;
        }
        if (!uniqueOrgs[this.tenantOrgInfo[i].orgCode]) {
          this.OrgList.push(this.tenantOrgInfo[i]);
          uniqueOrgs[this.tenantOrgInfo[i].orgCode] = 1;
        }
      });

      this.isAllOrderSearch = false;
      this.isTrack = false;
      this.totalRecords = 0;
      this.isOrderListDataExist = false;
      //console.log("role=" + window.localStorage.getItem('role'));
      //console.log("action By Id in ngonit=" + window.localStorage.getItem('actionById'));
      this.SpinnerService.show();
      if (window.localStorage.getItem('role') == "42") {
        this.isTrack = true;
      }
      this.configuraionData = configurton.filter(x => x.role == window.localStorage.getItem('role'));
      let selectedFromDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      let selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));

      this.sharedService.actionById.subscribe(val => {

        //console.log(val);
      });
      this.sharedService.sessionId.subscribe(val => {

        //  this.from = val;

      });
      this.sharedService.role.subscribe(val => {
        this.role = val;
        //this.role ="42";

      });
      this.sharedService.headerDataRefund.subscribe(val => {
        if (window.localStorage.getItem('role') != "" && window.localStorage.getItem('role') != undefined) {
          this.getOrderData(val, 1, false, 11);
        }

      });

    });

  }

  onTenantSelect() {
    let selectedTenant = this.searchForm.get('selectedTenant').value;
    var results = this.OrgList.filter(function (entry) {
      if (selectedTenant && selectedTenant.indexOf(entry.tenantCode) >= 0) {
        return true;
      }
    });
    this.organizationsOfTenants = results;
  }

  onTenantdeSelect(item) {
    let chnagedOrgs = [];

    if (this.searchForm.get('selectedOrg').value) {
      this.searchForm.get('selectedOrg').value.forEach(i => {
        console.log(i, item)
        if (i != item.orgCode)
          chnagedOrgs.push(i)
      })

      this.searchForm.patchValue({ 'selectedOrg': chnagedOrgs });
      console.log(chnagedOrgs)

    }
  }

  resetTeantFilters() {
    this.searchForm.patchValue({ 'selectedTenant': [], 'selectedOrg': [] });
    this.organizationsOfTenants = []
  }

  onOrgSelect() {
    let selectedTenant = this.searchForm.get('selectedTenant').value;
    let selectedOrg = this.searchForm.get('selectedOrg').value;
  }

  getTenantNameBycode(tenantCode) {
    let name = this.tenantsList.find(item => { return item.tenantCode == tenantCode });
    return name?.tenantName ? name.tenantName : '';
  }

  getOrgNameByCode(orgCode) {
    let name = this.OrgList.find(item => { return item.orgCode == orgCode });
    return name?.orgName ? name.orgName : "";
  }

  getOrderData(orderStatus, page = 1, pagination,type) {

    if (!pagination) {
      // this.searchForm.reset();
      let selectedFromDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

      let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      let selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
      this.selectedDate(selectedFromDate, selectedToDate);
      this.selectedDate(selectedFromDate, selectedToDate);
    }

    this.totalRecords = 0;
    this.SpinnerService.show();
    this.isOrderListDataExist = false;
    ////console.log(this.SpinnerService.show());
    this.orderRequest = this.prepareGetOrderDataRequest(orderStatus,type);
    this.orderDetailsRes = [];

    console.log(`refundRequest`,this.orderRequest)
    this.omsServiceService.refundOrdersList(this.orderRequest).subscribe(
      (res) => {
        console.log(`refundOrdersList`,res)
        this.SpinnerService.hide();
          this.orderDetailsRes = res["data"];
          if (res["countn"] != null && res["countn"] >= 1) {

            this.datacount = res["countn"];
            this.totalRecords = this.datacount;
            if(type == 11){
              this.page=1
            }
            this.SpinnerService.hide();
            this.isOrderListDataExist = false;
          } else {
            this.isOrderListDataExist = true;
            this.datacount = 0;
          }
      }

    )
  }

  getOrderById(orderId) {
    // alert(this.status)
    this.SpinnerService.hide();
        // this.SpinnerService.show();
    let sessionId;
    this.sharedService.sessionId.subscribe(val => {
      sessionId = val;
      //this.role ="42";

    });

    const url=this._router.createUrlTree(['/escalation-details/' + orderId + '/' + this.status])


    // const url=this._router.createUrlTree(['/opdexecution/' + '/escalation-details/' + orderId + '/' + this.status], { queryParams: { session: sessionId } })

    window.open(url.toString(),'_blank')
  }


  pageChange(currentPage) {
    console.log(`currentPage`, currentPage);
    if (this.searchForm.get('status').value != 0 && this.searchForm.get('status').value != undefined) {
      let status = this.searchForm.get('status').value
      this.getOrderData(status, currentPage, true, 22);
    }else{
      console.log(`currentPage123`, currentPage);
      let selectedStatus;
      this.sharedService.headerSelectedRefund.subscribe(val => {
        //console.log("select status value=" + val);
        selectedStatus = val;
      });
      this.getOrderData(selectedStatus, currentPage, true, 22);
    }
  }

  search(searchFormData, page = 1) {   
    this.totalRecords = 0;
    this.orderDetailsRes = [];
    //if (this.searchForm.valid) {
    this.SpinnerService.show();
    this.searchFormRequest = {};
    // let fromDate = this.fromDate;
    let fromDate = this.currentDate
    let selectedStatus;
    this.sharedService.headerSelectedRefund.subscribe(val => {

      console.log("select status value=" + val);
      selectedStatus = val;

    });
    let selectedFromDate;
    let selectedToDate;
    if (fromDate != null && fromDate != undefined ) {
      let fromDateValue = fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
      selectedFromDate = this.sharedService.getStringDate(new Date(fromDateValue));
    } else {

      let fromDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() - 2) + "-" + new Date().getDate();

    }
    // let toDate = this.toDate;
    let toDate = this.maxDate;
    if (toDate != null && toDate != undefined ) {
      // let toDateValue = toDate.year + "-" + toDate.month + "-" + toDate.day;
      let toDateValue = toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();
      selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
    } else {

      let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      ;

    }
    this.searchFormRequest["dateFilter"] = this.constantsService.DATE_FILTER;
    let searchStatus: boolean = false;

    if (this.searchForm.get("searchByValue").value != null && this.searchForm.get("searchByValue").value != undefined) {
      // searchStatus = true;
      if (this.searchForm.get("searchBy").value == "MRN") {
        this.searchFormRequest["mrn"] = this.searchForm.get("searchByValue").value;
      }
      else if (this.searchForm.get("searchBy").value == "Order ID") {
        this.searchFormRequest["order_id"] = this.searchForm.get("searchByValue").value;
      }
      else if (this.searchForm.get("searchBy").value == "Order Did") {
        this.searchFormRequest["order_did"] = this.searchForm.get("searchByValue").value;
      }

    } else {
      this.searchFormRequest["startDate"] = selectedFromDate;
      this.searchFormRequest["endDate"] = selectedToDate;
    }

    //status search begins
    if (this.searchForm.get("searchByValue").value == null && this.searchForm.get("searchByValue").value == undefined) {
      if (searchFormData.controls.status.value != 0 && searchFormData.controls.status.value != undefined) {
        this.status = searchFormData.controls.status.value;
        console.log(`search_status`,this.status)

        this.searchFormRequest["search_refund_status"] = this.status;

      }
    }

    if (this.pageSize != 0 && this.page != 0) {
      this.searchFormRequest["sortBy"] = this.constantsService.SORT_BY;
      this.searchFormRequest["limit"] = this.pageSize;
      // this.searchFormRequest["skip"] = this.pageSize * (this.page - 1);
      this.searchFormRequest["skip"] = 0;
    }

    this.searchFormRequest["isInternalCall"] = 1;
    this.searchFormRequest["action"] = 'OMS/api/operation.php/v1/update/refund/info';
    this.searchFormRequest["type"] = 'post';


  console.log('searchFormRequest',this.searchFormRequest)

    this.omsServiceService.refundOrdersList(this.searchFormRequest).subscribe(
      (res) => {

          this.orderDetailsRes = res["data"];
        console.log('refundOrdersList',this.orderDetailsRes)
        if (res["countn"] != null && res["countn"] >= 1) {
          this.datacount = res["countn"];
          this.totalRecords = this.datacount;
          this.page =1;
          //this.SpinnerService.hide();
          this.isOrderListDataExist = false;
        } else {
          this.isOrderListDataExist = true;
          this.datacount = 0;
        }
        this.SpinnerService.hide();
      }

    )
    this.SpinnerService.hide();
  }


  getDate(val: any) {

    let dateEntered = val.target.value;

  }
  refundOrder_recipts(orderId) {
    const modalRef = this.modalService.open(TrackOrderComponent, { windowClass: 'commonStyleModals modalWidth90p' });
    const closeModelRef = modalRef.result.then(
      (res) => {
      }
    );
    modalRef.componentInstance.order_id = orderId;
    modalRef.componentInstance.order_receipt = 'receipt_details';
  }

  update_refundOrderStatus(RefundID,orderId,odId,transactionCode,amount,type,reason,status) {
    console.log('update_refundOrderStatus',RefundID.$id,orderId,transactionCode,amount,type,reason,status)
    if(status == 3){
          const modalRef = this.modalService.open(TrackOrderComponent, { windowClass: 'commonStyleModals modalWidth90p' });
          const closeModelRef = modalRef.result.then(
            (res) => {
            }
          );
          modalRef.componentInstance.refund_id = RefundID.$id;
          modalRef.componentInstance.order_id = orderId;
          modalRef.componentInstance.odid = odId;
          modalRef.componentInstance.amount = amount;
          modalRef.componentInstance.status = status;
          modalRef.componentInstance.order_receipt = 'processing_refundOrder';
		}else{
			if(status == 4){ 
          const modalRef = this.modalService.open(TrackOrderComponent, { windowClass: 'commonStyleModals modalWidth90p' });
          const closeModelRef = modalRef.result.then(
            (res) => {
            }
          );
          modalRef.componentInstance.order_id = orderId;
          modalRef.componentInstance.order_receipt = 'refund_rejected';              
			}else{
        let requestData = {};
        requestData["refund_id"] = RefundID.$id;
        requestData["order_id"] = orderId;
        requestData["status"] = status;
        requestData["transaction_type"] = type;
        requestData["transaction_code"] = transactionCode;
        requestData["amount"] = amount;
        requestData["reason"] = reason;
        requestData["user_id"] = window.localStorage.getItem('actionById');
        requestData["username"] = window.localStorage.getItem('actionByName');
        requestData["isInternalCall"] = 1;
        requestData["action"] = 'OMS/api/operation.php/v1/update/refund/info';
        requestData["type"] = 'post';

          this.omsServiceService.updateRefundOrder(requestData).subscribe(
          (res) => {
               console.log(`updateRefundOrder`, res);
                if (res["status"] == 1) {
                  this.toastr.success(res["message"]);
                    setTimeout(function(){                          
                      window.location.reload();
                    }, 2000);
                } 
          })   
			}   
		}
           
  }

  confirmOrder(obj) {

    let orderConfirmationRequest = {};

    orderConfirmationRequest["order_id"] = [obj.order.patientinfo.order_id];
    orderConfirmationRequest["actionById"] = window.localStorage.getItem('actionById');;
    orderConfirmationRequest["actionByName"] = "UAT Madinaguda";
    orderConfirmationRequest["source"] = "1";
    // orderConfirmationRequest["comment"] = "Order confirmation";
    orderConfirmationRequest["reason"] = "";

    orderConfirmationRequest["role_id"] = this.constantsService.ROLE_ID;
    orderConfirmationRequest["status"] = 301;
    orderConfirmationRequest["type"] = "post";
    orderConfirmationRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
    // orderConfirmationRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    this.omsServiceService.orderConfirmation(orderConfirmationRequest).subscribe(
      (res) => {

      });

  }

  prepareGetOrderDataRequest(orderStatus,type) {
    this.orderRequest = {};

    this.orderRequest["dateFilter"] = this.constantsService.DATE_FILTER;
    let fromDateValue = new Date().getFullYear() + "-" + new Date().getMonth() + "-" + new Date().getDate();
    let fromDate = this.currentDate
    let selectedFromDate;
    if (fromDate != null && fromDate != undefined ) {
      let fromDateValue = fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
      selectedFromDate = this.sharedService.getStringDate(new Date(fromDateValue));

    }

    this.orderRequest["startDate"] = selectedFromDate;
    let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 2) + "-" + new Date().getDate();
    let selectedToDate;
    let toDate = this.maxDate;
    if (toDate != null && toDate != undefined ) {
      let toDateValue = toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();
      selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
    }
    this.orderRequest["endDate"] = selectedToDate;

     if (this.pageSize != 0 && this.page != 0 && type == 22) {
      this.orderRequest["sortBy"] = this.constantsService.SORT_BY;
      this.orderRequest["limit"] = this.pageSize;
      this.orderRequest["skip"] = this.pageSize * (this.page - 1);
    }else{
      this.orderRequest["sortBy"] = this.constantsService.SORT_BY;
      this.orderRequest["limit"] = this.pageSize;
      this.orderRequest["skip"] = 0;
    }

      this.orderRequest["search_refund_status"] = orderStatus; 

      this.orderRequest["associateId"] = "";
      this.orderRequest["associateBranchId"] = "";
      this.orderRequest["isInternalCall"] = 1;
      this.orderRequest["action"] = "OMS/api/operation.php/v1/order/refund";
      this.orderRequest["type"] = "post";

    return this.orderRequest;

  }

  loadReports(order) {

    // //console.log("load");
    const modalRef = this.modalService.open(ReportDetailsComponent);
    modalRef.componentInstance.reportDocInfo = order;
    const closeModelRef = modalRef.result.then(
      (res) => {

        //this.getOrderDataById(this.id);

      }

    );
  }

  getDiagnostiCenterData() {

    let diagnosticCenterApi = {};
    diagnosticCenterApi["business_id"] = "3";
    diagnosticCenterApi["name"] = "test";
    diagnosticCenterApi["limit"] = 1000;
    diagnosticCenterApi["offset"] = 0;


    this.omsServiceService.getDiagnosticData(diagnosticCenterApi).subscribe(

      (res) => {
        if (res["status"] == "Success") {
          if (res["dataObject"] != null && res["dataObject"] != undefined) {
            for (let data of res["dataObject"]) {
              //console.log(data.code);
              //console.log(data.name);
              this.diagnosticCenterList.push({ "code": data.code, name: data.name });
            }
          }

        }
      }

    )
  }

  clear() {


    //this.searchByValue = "": 
    //console.log("clear");
    this.searchForm.reset({
      status: '1'
    });
    this.currentDate=new Date()
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.currentDate, this.maxDate];
    this.currentDate=new Date()
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.currentDate, this.maxDate];

    // this.searchForm.

  }

  download(Id)
  {
    window.open(environment.invoiceDownload+Id,'_blank'); 
  }

  invoiceDownload(Id)
  {
    window.open(environment.prescriptionPrint+Id,'_blank');    
  }

  redirectPage(page){

    let sessionId;
    this.sharedService.sessionId.subscribe(val => {
      sessionId = val;
    });

    const url=this._router.createUrlTree(['/escalations/' + page])
    // const url=this._router.createUrlTree(['/opdexecution/' + '/escalations/' + page], { queryParams: { session: sessionId } })
    window.open(url.toString())
  }


  opentrackOrderModal(orderId) {
    //console.log(this.orderDetailsRes);
    const modalRef = this.modalService.open(TrackOrderComponent, { windowClass: 'commonStyleModals modalWidth90p' });
    const closeModelRef = modalRef.result.then(
      (res) => {

        //this.getOrderDataById(this.id);

      }

    );

    modalRef.componentInstance.order_id = orderId;


  }

  onValueChange(value: Date): void {
    var data = value;
    this.currentDate=data[0]
    this.maxDate=data[1]
    console.log(`data`, this.currentDate);
  }

  selectedDate(fromDate, endDate) {
    if (fromDate) {
      const [year, month, day] = fromDate.split('-');
      const obj = {
        year: parseInt(year), month: parseInt(month), day:
          parseInt(day.split(' ')[0].trim())
      };
      // this.fromDate = obj;
    }

    if (endDate) {
      const [year, month, day] = endDate.split('-');
      const obj = {
        year: parseInt(year), month: parseInt(month), day:
          parseInt(day.split(' ')[0].trim())
      };
      // this.endDate = obj;
    }
    this.searchForm.patchValue({ 'startDate': this.fromDate, 'endDate': this.endDate });
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

}
